(function () {

  'use strict';

  function pxWorkflowsList(
    $timeout, $filter, toastr, WorkflowService, WORKFLOW_LIST_FILTERS,
    WorkflowPagingParams, $ngBootbox, EventServiceEvents, CopilotService
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/workflows/workflows-list.template.html',
      link: function (scope, element) {

        let scrollEnd = null;
        let containerHeight = null;
        scope.workflowPagingParams = new WorkflowPagingParams();
        scope.loadingPage = true;
        scope.totalPages = null;
        scope.searchString = '';
        let originalList = [];
        let pageSet = [];

        scope.filtersList = WORKFLOW_LIST_FILTERS;
        scope.requestType = 'GET';

        scope.workflowContainer = null;
        scope.checkAllCheckboxes = false;
        scope.selectedWorkflows = 0;
        scope.nestedContext = null;

        (() => {
          setListeners();
          scrollListener();
          fulfillCopilotRequest();
        })();

        function resetList() {
          originalList = [];
          scope.workflowContainer.list = [];
          pageSet = [];
          angular.element('#WORKFLOW_SCROLL_CONTAINER').scrollTop(0);
        }

        function getFirstPage() {
          scope.loadingPage = true;
          scope.workflowPagingParams.pagingCriteria.page = 0;
          WorkflowService.getWorkflowList(scope.workflowPagingParams).then(function (response) {
            if (scope.workflowContainer) {
              resetList();
            }
            pageSet.push(response);
            scope.totalPages = response.page.totalPages;
            convertFileNamesForDisplay(response.list);
            originalList = angular.copy(response.list);
            scope.workflowContainer = response;
            scope.loadingPage = false;
          }).catch(function () {
          });
        }

        scope.getFirstPage = function () {
          getFirstPage();
        };

        scope.search = function () {
          scope.workflowPagingParams.pagingCriteria.match = scope.searchString;
          resetList();
          getFirstPage();
        };

        function getNextPage() {
          if (!scope.loadingPage && scope.totalPages > scope.workflowPagingParams.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.workflowPagingParams.pagingCriteria.page += 1;
            WorkflowService.getWorkflowList(scope.workflowPagingParams).then((response) => {
              if (response.list) {
                pageSet.push(response);
                convertFileNamesForDisplay(response.list);
                originalList = originalList.concat(angular.copy(response.list));
                scope.workflowContainer.list = scope.workflowContainer.list.concat(response.list);
              }
              scope.loadingPage = false;
            }).catch(function () {
            });
          }
        }

        function updateList() {
          scope.loadingPage = true;
          const tempPageSize = (pageSet[pageSet.length - 1].page.number + 1) * 20;
          scope.workflowPagingParams.pagingCriteria.pageSize = tempPageSize;
          scope.workflowPagingParams.pagingCriteria.page = 0;
          WorkflowService.getWorkflowList(scope.workflowPagingParams).then((response) => {
            scope.workflowPagingParams.pagingCriteria.pageSize = 20;
            scope.workflowPagingParams.pagingCriteria.page = (pageSet[pageSet.length - 1].page.number + 1).page;
            convertFileNamesForDisplay(response.list);
            scope.workflowContainer.list = response.list;
            scope.loadingPage = false;
          }).catch(function () {
          });
        }

        function convertFileNamesForDisplay(workflows) {
          workflows.forEach(function (workflow) {
            workflow.customProperties.fileName = convertMetadataReferences(workflow.formModel.metadataProfile.metadataFields, workflow.formModel.fileName);
          });
        }

        function convertMetadataReferences(metadataFields, stringWithReferences) {
          if (metadataFields?.length && stringWithReferences) {
            metadataFields.forEach(function (metadata) {
              const from = `{${metadata.id}${metadata.type === 'LOOKUP' ? ',0' : ''}}`;
              const to = `{${metadata.name}}`;
              stringWithReferences = stringWithReferences.replaceAll(from, to);
            });
          }
          return stringWithReferences;
        }

        scope.selectAllItems = function () {
          angular.forEach(scope.workflowContainer.list, function (value) {
            value.options.isSelected = scope.checkAllCheckboxes;
          });
        };

        function getWorkflow(workflowID) {
          WorkflowService.getWorkflowById(workflowID).then(function (updatedWorkflow) {
            convertFileNamesForDisplay([updatedWorkflow]);
            const index = scope.workflowContainer.list.findIndex(workflow => { return workflow.id === workflowID; });
            scope.workflowContainer.list[index] = updatedWorkflow;
          }).catch(function () {
          });
        }

        scope.$watch(function () {
          if (scope.workflowContainer) {
            return scope.workflowContainer.list;
          }
        }, function () {
          if (scope.workflowContainer) {
            scope.selectedWorkflows = scope.workflowContainer.list.findAllElements({
              options: {
                isSelected: true
              }
            }).length;
            if (!scope.selectedWorkflows) {
              scope.checkAllCheckboxes = false;
            } else {
              scope.checkAllCheckboxes = (scope.selectedWorkflows === scope.workflowContainer.list.length);
            }
          }
        }, true);

        scope.deleteWorkflows = function (workflow) {
          const selectedWorkflows = workflow ? [workflow] : scope.workflowContainer.list.findAllElements({ options: { isSelected: true } });
          let warning = '';
          if (selectedWorkflows.length === 1) {
            warning = $filter('stringular')($filter('translate')('DeleteWorkflow'), selectedWorkflows[0].info.name);
          } else {
            warning = $filter('stringular')($filter('translate')('DeleteWorkflows'), selectedWorkflows.length);
          }
          $ngBootbox.confirm(warning).then(function () {
            WorkflowService.deleteSelected(selectedWorkflows, function () {
              let toast = '';
              if (selectedWorkflows.length === 1) {
                toast = $filter('stringular')($filter('translate')('WorkflowDeleted'), selectedWorkflows[0].info.name);
              } else {
                toast = $filter('stringular')($filter('translate')('WorkflowsDeleted'), selectedWorkflows.length);
              }
              toastr.success(toast);
            });
          }).catch(function () {
          });
        };

        scope.deleteWorkflow = function (workflow) {
          scope.deleteWorkflows(workflow);
        };

        scope.openListMenu = function (event, workflow) {
          scope.closeAllMenus();
          const position = document.getElementById(event.target.id).getBoundingClientRect();
          $timeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = workflow;
            scope.listMeta = {
              position: { left: position.x, top: position.y },
              parentId: event.target.id,
              type: 'workflowList',
              scrollContainerId: 'WORKFLOW_SCROLL_CONTAINER'
            };
            scope.$apply();
          }, 50);
        };

        scope.closeAllMenus = function () {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextContent = null;
        };

        scope.closeListMenu = function (workflow, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;
          switch (action) {
            case 'DELETE_WORKFLOW':
              scope.deleteWorkflow(workflow);
              break;
          }
        };

        scope.openCreateWorkflowDialog = function () {
          scope.createWorkflowDialogIsOpen = true;
        };

        scope.closeCreateWorkflowDialog = function () {
          scope.createWorkflowDialogIsOpen = false;
        };

        scope.reloadList = function () {
          getFirstPage();
        };

        // TOOLTIP STUFF
        scope.showTooltip = function (showTip, position, type, context) {
          if (showTip) {
            tooltip(position, type, context);
          } else {
            scope.clearTooltip();
          }
        };

        function tooltip(position, type, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: type.charAt(0).toUpperCase() + type.slice(1),
            type,
            context
          };
          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

        scope.scrollingLEFT = false;
        scope.scrollingTOP = false;

        function scrollListener() {
          let scrollLeft = 0;
          angular.element('#WORKFLOW_SCROLL_CONTAINER').on('scroll', function (event) {
            if (event.currentTarget.scrollLeft !== scrollLeft) {
              scope.scrollingLEFT = true;
              scrollLeft = event.currentTarget.scrollLeft;
              scope.$apply();
            } else {
              scope.scrollingLEFT = false;
            }

            if (scope.scrollingLEFT) {
              $timeout(() => {
                scope.scrollingLEFT = false;
              }, 1500);
            }

            scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 30;
            containerHeight = event.currentTarget.scrollHeight;

            if (!scope.loadingPage && scope.totalPages > scope.workflowPagingParams.pagingCriteria.page + 1) {
              if (scrollEnd > containerHeight) {
                $timeout(function () {
                  getNextPage();
                }, 300);
              }
            }
          });

          // WORKFLOW_SCROLL_CONTAINER
        }

        function setListeners() {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKFLOW_CREATED, function (name, data) {
            if (pageSet.length <= 1) {
              getFirstPage();
            } else {
              updateList();
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKFLOW_DELETED, function (name, data) {
            if (pageSet.length <= 1) {
              getFirstPage();
            } else {
              updateList();
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKFLOW_UPDATED, function (name, data) {
            const workflowID = data.workflow.split('/').pop();
            if (scope.workflowContainer && scope.workflowContainer.list) {
              if (scope.workflowContainer.list.find(workflow => workflow.id === workflowID)) {
                getWorkflow(workflowID);
              }
            }
          });
        }

        function fulfillCopilotRequest() {
          const copilotActionButton = element.find('[copilot-action]')[0];
          if (!copilotActionButton) { return; }
          const copilotAction = copilotActionButton.getAttribute('copilot-action');
          if (!copilotAction || CopilotService.state.requestedAction.responseType !== copilotAction) {
            return;
          }
          $timeout(function () {
            scope.openContext(null,
              { name: 'CreateCaptureWorkflow', title: 'CreateCaptureWorkflow', dontUseTitle: false, dontUseName: true },
              { title: 'CreateCaptureWorkflow', type: 'createWorkflow', name: 'CreateCaptureWorkflow', bypassCloseOutside: true }
            );
          }, 100);
        }

        scope.$on('$destroy', function () {
          angular.element('#WORKFLOW_SCROLL_CONTAINER').off('scroll', function () {});
        });

      }
    };
  }

  pxWorkflowsList.$inject = [
    '$timeout', '$filter', 'toastr', 'WorkflowService', 'WORKFLOW_LIST_FILTERS',
    'WorkflowPagingParams', '$ngBootbox', 'EventServiceEvents', 'CopilotService'
  ];

  angular
    .module('printix-admin')
    .directive('pxWorkflowsList', pxWorkflowsList)
    .constant('WORKFLOW_LIST_FILTERS', [
      {
        name: 'Source',
        parameter: 'sources',
        type: 'checkbox',
        values: [{
          key: 'MFP',
          value: 'Printer',
          type: 'checkbox'
        },
        {
          key: 'PHONE',
          value: 'Mobile',
          type: 'checkbox'
        }
          // {
          //   key: 'COMPUTER',
          //   value: 'Computer',
          //   type: 'checkbox'
          // }
        ]
      },
      {
        name: 'Active',
        parameter: 'active',
        type: 'radio',
        values: [
          {
            key: 'active',
            value: 'Yes',
            state: true
          },
          {
            key: 'active',
            value: 'No',
            state: false
          },
          {
            key: 'active',
            value: 'ClearFilter',
            state: null
          }
        ]
      }
    ]);

})();
